"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icon_info_model_1 = require("../../../controls/documents/document-preview-control/model/icon-info.model");
var file_utils_1 = require("../../utils/file-utils");
var IconInfoProviderService = /** @class */ (function () {
    function IconInfoProviderService() {
    }
    IconInfoProviderService.SUPPORTED_FILE_ICONS = [
        // Documents
        {
            formats: ['.txt'],
            iconId: 'file-text',
            iconRegistry: 'ejustice.svg',
            color: '#0c95fb',
            mimeTypeName: 'Text'
        },
        {
            formats: ['.pdf'],
            iconId: 'pdf',
            iconRegistry: 'ejustice.svg',
            color: '#f85c53',
            mimeTypeName: 'Adobe Portable Document Format'
        },
        {
            formats: ['.xls'],
            iconId: 'excel',
            iconRegistry: 'ejustice.svg',
            color: '#0dbb74',
            mimeTypeName: 'Microsoft Excel'
        },
        {
            formats: ['.xlsx'],
            iconId: 'excel',
            iconRegistry: 'ejustice.svg',
            color: '#0dbb74',
            mimeTypeName: 'Microsoft Excel (OpenXML)'
        },
        {
            formats: ['.doc'],
            iconId: 'word',
            iconRegistry: 'ejustice.svg',
            color: '#0c95fb',
            mimeTypeName: 'Microsoft Word'
        },
        {
            formats: ['.docx'],
            iconId: 'word',
            iconRegistry: 'ejustice.svg',
            color: '#0c95fb',
            mimeTypeName: 'Microsoft Word (OpenXML)'
        },
        {
            formats: ['.ppt'],
            iconId: 'ppt',
            iconRegistry: 'ejustice.svg',
            color: '#d04424',
            mimeTypeName: 'Power Point'
        },
        {
            formats: ['.pptx'],
            iconId: 'ppt',
            iconRegistry: 'ejustice.svg',
            color: '#d04424',
            mimeTypeName: 'Power Point'
        },
        // Video
        {
            formats: file_utils_1.VIDEO_FORMATS,
            iconId: 'videocamera',
            iconRegistry: 'ejustice.svg',
            color: '#0c95fb',
            mimeTypeName: 'Video'
        },
        // Audio
        {
            formats: file_utils_1.AUDIO_FORMATS,
            iconId: 'audio',
            iconRegistry: 'ejustice.svg',
            color: '#0c95fb',
            mimeTypeName: 'Audio'
        },
        // Image
        {
            formats: file_utils_1.IMAGE_FORMATS,
            iconId: 'image',
            iconRegistry: 'ejustice.svg',
            color: '#de3690',
            mimeTypeName: 'Image'
        }
    ];
    IconInfoProviderService.getFileIconInfo = function (format) {
        format = format.startsWith('.') ? format : "." + format;
        format = format.toLocaleLowerCase();
        return IconInfoProviderService.SUPPORTED_FILE_ICONS.find(function (fileIcon) { return fileIcon.formats.includes(format); });
    };
    IconInfoProviderService.getIconInfo = function (format) {
        format = format.startsWith('.') ? format : "." + format;
        format = format.toLocaleLowerCase();
        var iconData = IconInfoProviderService.SUPPORTED_FILE_ICONS.find(function (fileIcon) { return fileIcon.formats.includes(format); });
        return new icon_info_model_1.IIconInfo(iconData.iconId, iconData.color, iconData.iconRegistry);
    };
    IconInfoProviderService.getIconPath = function (iconInfo) {
        return iconInfo ? ('icons/' + iconInfo.iconRegistry + '#' + iconInfo.iconId) : '';
    };
    return IconInfoProviderService;
}());
exports.IconInfoProviderService = IconInfoProviderService;
//# sourceMappingURL=icon-info-provider.service.js.map